/**
 * Booking sidebar badge store.
 * Written by `<BookingBadgeSubscriber />`; read by `bookingsMenu`.
 */

import { create } from 'zustand';

interface BookingBadgesState {
  pendingApprovals: number;
  overdue: number;
  setFromMetrics: (m: Partial<Pick<BookingBadgesState, 'pendingApprovals' | 'overdue'>>) => void;
  reset: () => void;
}

const EMPTY = { pendingApprovals: 0, overdue: 0 };

export const useBookingBadgesStore = create<BookingBadgesState>((set) => ({
  ...EMPTY,
  setFromMetrics: (m) =>
    set({
      pendingApprovals: m.pendingApprovals ?? 0,
      overdue: m.overdue ?? 0,
    }),
  reset: () => set(EMPTY),
}));
